/** Faz 8 — Android app sales report screen (F8-16), English. Added to `mobile.en.ts` with one line (ADR-801). */
export const mobileFaz8En = {
  salesReport: {
    title: 'Sales report',
    open: 'Open sales report',
    hint: 'Net sales, orders, average order, new customers',
    presets: { today: 'Today', last_7: 'Last 7 days', this_month: 'This month', last_month: 'Last month' },
    periodLabel: 'Period',
    netSales: 'Net sales',
    orders: 'Orders',
    averageOrder: 'Average order',
    newCustomers: 'New customers',
    deductions: 'Returns and cancellations',
    itemsSold: 'Units sold',
    vsPrevious: '{{change}} vs previous period',
    up: '{{pct}}% up',
    down: '{{pct}}% down',
    flat: 'no change',
    new: 'none in previous period',
    dailyTitle: 'By day',
    dailyRow: '{{orders}} orders',
    topProducts: 'Top-selling products',
    productRow: '{{quantity}} units',
    noSales: 'No sales in this period.',
    partial: 'The period is not over; today’s figures may still change.',
    awaiting: '{{count}} orders awaiting payment ({{amount}}) are not counted as sales.',
    fxMissing: '{{count}} foreign-currency orders without an exchange rate were left out.',
    definition:
      'Confirmed orders (paid, processing, shipped, delivered, completed); amounts in TRY incl. VAT, after returns and cancellations. Same definition as the panel.',
    morePanel: 'Breakdowns, files and the finance report are in the panel.',
    noPermission: 'The sales reports permission is needed to see sales figures.',
  },
};
